var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _polygon, _polygon2, _g2, _rect17, _g3, _path, _circle, _circle2, _circle3, _g4, _g5, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnrikabluelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.6 190.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #033aa8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #3170de;\n      }\n\n      .cls-4 {\n        fill: #092b9c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Storage_",
    "data-name": "&lt;Storage&gt;"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 115.36,
    cy: 51.18,
    rx: 6.57,
    ry: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.79,52.84v3.3c3.62,1.23,9.71,1.04,13.13,0v-3.3c-4.14.97-8.15,1.04-13.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.79,57.13v3.3c3.62,1.23,9.71,1.04,13.13,0v-3.3c-4.14.97-8.15,1.04-13.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.79,61.28v3.3c3.62,1.23,9.71,1.04,13.13,0v-3.3c-4.14.97-8.15,1.04-13.13,0Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.71,
    y: 69.42,
    width: 1.13,
    height: 2.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.03,
    y: 67.92,
    width: 1.13,
    height: 7.77,
    transform: "translate(46.79 190.4) rotate(-90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.36,
    y: 71.24,
    width: 1.13,
    height: 2.95
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.77,
    y: 65.81,
    width: 1.13,
    height: 7.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.83,
    y: 55.75,
    width: 1.13,
    height: 21.25,
    transform: "translate(203.77 -71.02) rotate(90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 146.89,
    y: 64.3,
    width: 1.13,
    height: 2.63
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 133.31,
    y: 76.76,
    width: 1.13,
    height: 7.62
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.33,
    y: 70.74,
    width: 1.13,
    height: 13.17,
    transform: "translate(217.23 -62.57) rotate(90)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.35,
    y: 76.76,
    width: 1.13,
    height: 5.23
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 132.69,
    y: 82.64,
    width: 1.13,
    height: 2.37,
    transform: "translate(49.44 217.08) rotate(-90)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.92,
    y: 49.55,
    width: 14.93,
    height: 6.57
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.92,
    y: 56.99,
    width: 14.93,
    height: 2.11
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.57,
    y: 60.9,
    width: 3.62,
    height: 1.62
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 138.8,
    y: 84.38,
    width: 13.81,
    height: 7.13
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.56,
    y: 91.51,
    width: 2.28,
    height: 1.35
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 137.03,
    y: 94.06,
    width: 17.35,
    height: 1.12
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.71 76.59 127.9 76.59 123.79 80.76 110.48 80.76 114.71 76.59"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.68 77.33 124.95 81.99 124.95 94.06 129.68 89.28 129.68 77.33"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.82,2.84l8.3,8.34-8.36,8.35-8.24-8.29,8.3-8.39M131.81,0l-11.11,11.24,11.05,11.12,11.19-11.18-11.13-11.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.77,170.58l8.3,8.34-8.36,8.35-8.24-8.29,8.3-8.39M131.76,167.74l-11.11,11.24,11.05,11.12,11.19-11.18-11.13-11.18h0Z"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.99,
    y: 85.35,
    width: 5.03,
    height: 4.61
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.68,
    y: 87.37,
    width: 6.34,
    height: 5.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.37,88.02v4.61h-5.04v-4.61h5.04M121.67,86.72h-7.64v7.21h7.64v-7.21h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.79,82.63v12.44h14.27v-12.44h-14.27ZM121.67,93.93h-7.64v-2.66h-3.34v-7.21h7.64v2.66h3.34v7.21Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 142.52,
    cy: 88.19,
    r: 0.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 145.7,
    cy: 88.19,
    r: 0.93
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 148.98,
    cy: 88.19,
    r: 0.93
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_ANRIKA_",
    "data-name": "&lt;ANRIKA&gt;"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.33 106.09 0 143.56 13.94 143.56 34.95 115 28.33 106.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.7 126.2 42.49 143.56 56.43 143.56 36.55 117.29 29.7 126.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "90.24 130.43 70.37 106.09 56.43 106.09 56.43 143.56 67.85 143.56 67.85 120.03 87.04 143.56 100.98 143.56 100.98 106.09 90.24 106.09 90.24 130.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.74,106.09h-32.47v37.47h10.74v-13.14h13.9l8.26,13.14h11.42l-8.01-13.62c12-4.07,10.27-23.85-3.84-23.85ZM135.66,119.75h-21.56v-2.38h21.56c.68.69.68,1.66,0,2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "148.71 106.09 149.09 143.56 160.39 143.56 160.09 106.09 148.71 106.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "207.17 106.59 194.67 106.59 186.81 119.08 172.84 119.08 172.94 106.09 161.6 106.09 161.6 143.56 172.89 143.56 172.89 130.58 186.5 130.58 195.04 143.56 207.17 143.56 194.93 125.2 207.17 106.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "235.5 106.09 207.17 143.56 221.11 143.56 242.12 115 235.5 106.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "243.72 117.29 236.87 126.2 249.66 143.56 263.6 143.56 243.72 117.29"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.34 90.61 117.67 90.61 117.67 84.71 117.67 90.61 111.34 90.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.32,84.06h-7.64v7.21h7.64v-7.21h0ZM111.99,89.96v-4.61h5.03v4.61h-5.03Z"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.41 19.54 36.9 95.11 46.22 104.44 47.06 102.44 39.73 95.13 112.41 22.36 131.76 41.65 151.06 22.36 223.81 95.05 216.43 102.44 217.26 104.44 226.63 95.05 151.06 19.54 131.76 38.83 112.41 19.54"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.96 145.22 112.53 170.81 131.7 151.64 151 170.81 176.54 145.22 173.63 145.23 150.99 167.99 131.7 148.82 112.53 167.98 89.78 145.22 86.96 145.22"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "106.55 145.54 131.76 170.81 157.05 145.54 154.19 145.54 131.76 167.98 109.38 145.53 106.55 145.54"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "131.76 19.54 56.2 95.08 65.54 104.44 66.37 102.43 59.03 95.07 131.76 22.36 204.61 95.17 197.34 102.43 198.17 104.44 207.44 95.17 131.76 19.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnrikabluelogo);
export default __webpack_public_path__ + "static/media/anrikabluelogo.4bf84d0fdba2b2ad780dcb56f3dd05ca.svg";
export { ForwardRef as ReactComponent };